import { ReactLoadable } from "@/component/ReactLoadable/lazyLoad.jsx";
export type IRoute = {
    path: string;
    exact?: boolean;
    name: string;
    icon?: string;
    comp?: any;
    subRoutes?: Array<IRoute>;
    redirect?: string;
};

export const routes: Array<IRoute> = [
    {
        path: "/dashboard",
        exact: true,
        name: "看板页",
        icon: "home",
        comp: ReactLoadable(() => import("../view/dashboard/dashboard")),
    },
    {
        path: "/loginInne",
        name: "登陆",
        icon: "login",
        subRoutes: [
            {
                path: "loginInne",
                name: "登陆",
                comp: ReactLoadable(() => import("../view/login/login")),
            },
        ],
    },
    {
        path: "/",
        exact: true,
        name: "主页",
        redirect: "/index",
        icon: "home",
        subRoutes: [
            {
                path: "index",
                name: "主页",
                comp: ReactLoadable(() => import("../view/index/Index")),
            },
        ],
    },

    {
        path: "/eCommerce",
        exact: true,
        name: "电商",
        redirect: "/eCommerce/eCommercoDaily",
        icon: "eCommerce",
        subRoutes: [
            {
                path: "/eCommercoDaily",
                name: "经营日报表",
                comp: ReactLoadable(
                    () => import("../view/eCommerce/eCommercoDaily")
                ),
            },
            {
                path: "/eCommercoDaily1",
                name: "MW经营日报表",
                comp: ReactLoadable(
                    () => import("../view/eCommerce/eCommercoDaily")
                ),
            },
            {
                path: "/eCommercoDaily2",
                name: "RL经营日报表",
                comp: ReactLoadable(
                    () => import("../view/eCommerce/eCommercoDaily")
                ),
            },
            {
                path: "/eCommercoDaily3",
                name: "GL经营日报表",
                comp: ReactLoadable(
                    () => import("../view/eCommerce/eCommercoDaily")
                ),
            },
            // {
            //     path: 'eCommercoSummary',
            //     name: '报表分析',
            //     comp: ReactLoadable(() => import('../view/eCommerce/eCommercoSummary')),
            // }
        ],
    },

    {
        path: "/eCommerce",
        exact: true,
        name: "经营分析",
        redirect: "/eCommerce/eCommercoAnalysis",
        icon: "eCommerce",
        subRoutes: [
            {
                path: "/eCommercoAnalysis",
                name: "集团经营日报表",
                comp: ReactLoadable(
                    () => import("../view/eCommerce/eCommercoAnalysis")
                ),
            },
            // {
            //     path: 'eCommercoSummary',
            //     name: '报表分析',
            //     comp: ReactLoadable(() => import('../view/eCommerce/eCommercoSummary')),
            // }
        ],
    },
    {
        path: "/eCommerce",
        exact: true,
        name: "营销分析",
        redirect: "/eCommerce/analysis",
        icon: "eCommerce",
        subRoutes: [
            {
                path: "/analysis",
                name: "营销分析",
                comp: ReactLoadable(
                    () =>
                        import(
                            "../view/eCommerce/marketAnalysis/eCommercoMarketAnalysis"
                        )
                ),
            },
            // {
            //     path: 'eCommercoSummary',
            //     name: '报表分析',
            //     comp: ReactLoadable(() => import('../view/eCommerce/eCommercoSummary')),
            // }
        ],
    },
];
